(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initHeader = (header) => {
      if (header.dataset.menuReady !== undefined) return;
      const toggle = header.querySelector('[data-menu-toggle]');
      const navigation = header.querySelector('.site-header__navigation');
      if (!toggle || !navigation) return;
      header.dataset.menuReady = '';

      const closeMenu = () => {
        toggle.setAttribute('aria-expanded', 'false');
        navigation.removeAttribute('data-menu-open');
      };
      toggle.addEventListener('click', () => {
        const opening = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(opening));
        navigation.toggleAttribute('data-menu-open', opening);
        if (opening) navigation.querySelector('a')?.focus({ preventScroll: true });
      });
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
        closeMenu();
        toggle.focus();
      });
      navigation.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-site-header]')) initHeader(scope);
      scope.querySelectorAll('[data-site-header]').forEach(initHeader);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-social-videos"] && !Shopify.designMode) return;
  try {
    
  const initSocialVideoCarousels = (scope) => {
    scope.querySelectorAll('[data-social-videos-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const list = carousel.querySelector('.product-social-videos__list');
      const videos = carousel.querySelectorAll('.product-social-videos__video');
      if (videos.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              const playResult = video.play();
              if (playResult && typeof playResult.catch === 'function') playResult.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '240px 0px', threshold: 0.25 });
        videos.forEach((video) => {
          video.controls = false;
          observer.observe(video);
        });
        const onUnload = (event) => {
          if (!event.target.contains(carousel)) return;
          observer.disconnect();
          videos.forEach((video) => video.pause());
          document.removeEventListener('shopify:section:unload', onUnload);
        };
        document.addEventListener('shopify:section:unload', onUnload);
      }
      const navigation = carousel.querySelector('[data-social-videos-navigation]');
      if (!navigation) return;
      const previous = navigation.querySelector('[data-social-videos-direction="-1"]');
      const next = navigation.querySelector('[data-social-videos-direction="1"]');
      const positionLabel = navigation.querySelector('[data-social-videos-position]');

      const updateArrows = () => {
        const max = list.scrollWidth - list.clientWidth;
        const position = Math.abs(list.scrollLeft);
        navigation.hidden = max <= 1;
        previous.disabled = position <= 1;
        next.disabled = position >= max - 1;
        if (positionLabel) {
          const cards = [...list.querySelectorAll('.product-social-videos__card')];
          const center = list.getBoundingClientRect().left + list.clientWidth / 2;
          const current = cards.reduce((closest, card, index) =>
            Math.abs(card.getBoundingClientRect().left + card.clientWidth / 2 - center)
              < Math.abs(cards[closest].getBoundingClientRect().left + cards[closest].clientWidth / 2 - center)
              ? index : closest, 0);
          positionLabel.textContent = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        }
      };

      navigation.addEventListener('click', (event) => {
        const button = event.target.closest('[data-social-videos-direction]');
        if (!button || button.disabled) return;
        const card = list.querySelector('.product-social-videos__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const direction = Number(button.dataset.socialVideosDirection);
        const rtl = getComputedStyle(list).direction === 'rtl' ? -1 : 1;
        list.scrollBy({
          left: rtl * direction * (card.getBoundingClientRect().width + gap),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      list.addEventListener('scroll', updateArrows, { passive: true });
      new ResizeObserver(updateArrows).observe(list);
      updateArrows();
    });
  };

  const prioritizeAdVideo = (scope) => {
    const adId = new URLSearchParams(window.location.search).get('ad_id');
    if (!adId) return;

    scope.querySelectorAll('.product-social-videos__list').forEach((list) => {
      const match = [...list.querySelectorAll('.product-social-videos__card[data-ad-id]')]
        .find((card) => card.dataset.adId === adId);
      if (match && match !== list.firstElementChild) list.prepend(match);
    });
  };

  prioritizeAdVideo(document);
  initSocialVideoCarousels(document);
  document.addEventListener('shopify:section:load', (event) => {
    prioritizeAdVideo(event.target);
    initSocialVideoCarousels(event.target);
  });

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!(event.target instanceof Element)) return;

    const card = event.target.closest('.product-social-videos__card');
    const list = card?.closest('.product-social-videos__list');
    if (!list) return;

    const cardBounds = card.getBoundingClientRect();
    const listBounds = list.getBoundingClientRect();
    const offset = cardBounds.left + cardBounds.width / 2 - (listBounds.left + listBounds.width / 2);
    if (Math.abs(offset) < 2) return;

    event.preventDefault();
    list.scrollBy({
      left: offset,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const duration = 45 * 60 * 1000;

    const init = (banner) => {
      if (banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';

      const key = banner.dataset.countdownKey;
      const now = Date.now();
      let announcement;
      const announcementObserver = new ResizeObserver(() => {
        banner.parentElement?.style.setProperty('--sale-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
      });
      const updateStickyOffset = () => {
        const current = document.querySelector('.announcement-bar--sticky');
        if (current !== announcement) {
          announcementObserver.disconnect();
          announcement = current;
          if (announcement) announcementObserver.observe(announcement);
        }
        banner.parentElement?.style.setProperty('--sale-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
      };
      updateStickyOffset();
      window.addEventListener('resize', updateStickyOffset, { passive: true });
      document.addEventListener('shopify:section:load', updateStickyOffset);
      let deadline;
      try {
        const stored = Number(localStorage.getItem(key));
        deadline = Number.isFinite(stored) && stored > now ? stored : now + duration;
        localStorage.setItem(key, String(deadline));
      } catch {
        deadline = now + duration;
      }

      const hours = banner.querySelector('[data-sale-unit="hours"]');
      const minutes = banner.querySelector('[data-sale-unit="minutes"]');
      const seconds = banner.querySelector('[data-sale-unit="seconds"]');
      const onUnload = (event) => {
        if (event.target.contains(banner)) cleanup();
      };
      const cleanup = () => {
        clearInterval(interval);
        announcementObserver.disconnect();
        window.removeEventListener('resize', updateStickyOffset);
        document.removeEventListener('shopify:section:load', updateStickyOffset);
        document.removeEventListener('visibilitychange', render);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      const render = () => {
        if (deadline <= Date.now()) {
          deadline = Date.now() + duration;
          try {
            localStorage.setItem(key, String(deadline));
          } catch {}
        }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
        seconds.textContent = String(remaining % 60).padStart(2, '0');
      };

      const interval = setInterval(render, 1000);
      document.addEventListener('visibilitychange', render);
      document.addEventListener('shopify:section:unload', onUnload);
      render();
    };

    const initAll = (scope) => scope.querySelectorAll('[data-sale-countdown]').forEach(init);
    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
